import React from 'react';

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
}

export const Checkbox: React.FC<CheckboxProps> = ({
  label,
  className = '',
  id,
  ...props
}) => {
  // Generate unique ID for label association
  const checkboxId = id || `checkbox-${React.useId()}`;
  
  return (
    <div className="flex items-center">
      <input
        id={checkboxId}
        type="checkbox"
        className={`checkbox-custom ${className}`}
        {...props}
      />
      {label && (
        <label htmlFor={checkboxId} className="ml-2 text-sm font-medium text-neutral-800 cursor-pointer">
          {label}
        </label>
      )}
    </div>
  );
};

export default Checkbox;
